var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYangming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 411,
    height: 130,
    viewBox: "0 0 411 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24828 3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 411,
    height: 130,
    transform: "translate(-24828 -3625)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24880.955 -3685.453)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.61 99.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.946,
    height: 52.946,
    fill: "#e82527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.13,103.376,77.346,125.1V149.67h9.515V124.376l14.794-21.5H92.43L81.888,118.386,71.215,102.88Z",
    transform: "translate(-55.081 -99.703)",
    fill: "#1d8ecd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.556,127.061,61.79,110.29l.281,40.659H69.89V135.584l3.665,5.353Z",
    transform: "translate(-55.022 -100.982)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.59,127.525v13.627l3.947-5.494v15.365h7.893v-40.3Z",
    transform: "translate(-60.856 -101.056)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.68-30.156H7.995L18.128-14.47l10.3-15.686H38.451L22.593-7.2V10.948H13.949V-7.2Zm53.813,0h9.16l17.518,41.1H69.193L65.414,1.158H47.553l-3.664,9.789h-9.1Zm4.236,8.186-6.011,15.8H62.609Zm25.3-8.186H92.607L109.438-.616l-.4-29.54h8.816v41.1H107.835L90.145-20.138l.4,31.085H81.673Zm59.48,23.987v-7.27H161.59V10.948H142.985a38.5,38.5,0,0,1-6.87-.6A13.444,13.444,0,0,1,129.932,7.4,14.9,14.9,0,0,1,125.123.557a27.863,27.863,0,0,1-1.488-8.272q-.057-.916-.029-1.775t.086-1.717q.63-9.732,5.3-14.312t14-4.58l18.605-.057v7.1H142.985q-6.125.057-7.929,4.322a23.793,23.793,0,0,0-1.8,9.36V-9.2a20.691,20.691,0,0,0,1.8,8.988q1.8,3.778,7.929,3.778l9.732-.057V-6.169Zm45.6-23.987h12.709L209.94,1.387l10.476-31.543h12.652v41.1H224.6l.687-32-10.534,32h-9.16L194.712-21.4l.859,32.345h-8.816Zm63.888,41.1H241.6v-41.1h9.045Zm8.53-41.1h10.934L286.938-.616l-.4-29.54h8.816v41.1H285.335l-17.69-31.085.4,31.085h-8.873Zm59.48,23.987v-7.27H339.09V10.948H320.485a38.5,38.5,0,0,1-6.87-.6A13.444,13.444,0,0,1,307.433,7.4,14.9,14.9,0,0,1,302.624.557a27.862,27.862,0,0,1-1.488-8.272q-.057-.916-.029-1.775t.086-1.717q.63-9.732,5.3-14.312t14-4.58l18.605-.057v7.1H320.485q-6.126.057-7.929,4.322a23.793,23.793,0,0,0-1.8,9.36V-9.2a20.691,20.691,0,0,0,1.8,8.988q1.8,3.778,7.929,3.778l9.732-.057V-6.169Z",
    transform: "translate(69.503 35.959)",
    fill: "#d92128"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYangming);
export default __webpack_public_path__ + "static/media/yangming.f21569ebe179f6c878678db0641d7069.svg";
export { ForwardRef as ReactComponent };